import React, {
	Component
} from 'react';
import Global from '../../Global';

import './ScrollingAD.css'; // Tell Webpack that Button.js uses these styles

import SwipeableViews from 'react-swipeable-views';
import { virtualize } from 'react-swipeable-views-utils';
import { mod } from 'react-swipeable-views-core';

const VirtualizeSwipeableViews = virtualize(SwipeableViews);


class Carousel extends React.Component {

	constructor(props) {
		super(props);
		this.state = {
			current: 0
		}
		this.apiCallPath = this.props.apiCallPath;
	}

	transitionEnd(index) {
		let apiState = this.props.apiCallPath;
		if(apiState === "smartphone-banners"){
			index = index % 2 < 0 ? index % 2 + 2 : index % 2;
		}
		else{
			index = index % 3 < 0 ? index % 3 + 3 : index % 3;
		}

		this.setState({
			current: index
		})
	}

	getDots() {
		let html = [0, 1, 2].map(index => {
			return <span key={index} className={this.state.current === index ? 'active' : ''}>{index}</span>
		});

		let apiState = this.props.apiCallPath;

		if(apiState === "smartphone-banners"){
			html = [0, 1].map(index => {
				return <span key={index} className={this.state.current === index ? 'active' : ''}>{index}</span>
			});
		}

		return html;
	}

	slideRenderer(params) {
	  const { index, key } = params;

	  let apiState = this.props.apiCallPath;

	  //console.log(apiState);

	  let bigBlock = null;

	  let modNo = 2;


		if(apiState !== "smartphone-banners"){
			modNo = 3;

			bigBlock = (
				<div className="ad-3-mobile"
					 style={{"backgroundImage":"url("+this.props.items[2].imageMob+")"}}
					 key={key}
				>
					<div className="col-md-6 texts">
						<h3>{this.props.items[2].headline}</h3>
						<div className="cutline"></div>
						<div className="text">{this.props.items[2].text}</div>
						<div className="priceAndBtnsWrap">
							<h5>{this.props.items[2].priceLabel}</h5>
							<div className="priceAndBtns">
								<div className="price"><span>$</span>{this.props.items[2].price}</div>
								{'\n'}
								<a href={this.props.items[2].ctaUrl} className="buy text-uppercase">{this.props.items[2].label}</a>
							</div>
						</div>
					</div>
				</div>
			);
		}

	  switch (mod(index, modNo)) {
	    case 0:
	      return (
	        <div className="ad-1-mobile"
                 style={{"backgroundImage":"url("+this.props.items[0].imageMob+")"}}
                 key={key}
                 >
					<h3>{this.props.items[0].headline}</h3>
					<div className="cutline"></div>
					<div className="text">{this.props.items[0].text}</div>
					<div className="btns">
						<a href={this.props.items[0].ctaUrl} className="buy text-uppercase">{this.props.items[0].label}</a>
					</div>
				</div>
	      );

	    case 1:
	      return (
	        	<div className="ad-2-mobile" 
					style={{"backgroundImage":"url("+this.props.items[1].imageMob+")"}}
					key={key}
					>
					<h3>{this.props.items[1].headline1}<br/>{this.props.items[1].headline2}</h3>
					<div className="cutline"></div>
					<div className="text">{this.props.items[1].text}</div>
					<div className="btns">
						<a href={this.props.items[1].ctaUrl} className="buy text-uppercase">{this.props.items[1].label}</a>
					</div>
				</div>
	      );

	    case 2:
	      return bigBlock;

	    default:
	      return null;
	  }
	}

	render() {
		return (
			[<VirtualizeSwipeableViews enableMouseEvents className="carousel" key="1" slideRenderer={this.slideRenderer.bind(this)} onChangeIndex={this.transitionEnd.bind(this)} ></VirtualizeSwipeableViews>, [
				<div className="dots" key="2">
            	{this.getDots()}
            </div>
			]]
		);
	}
}


class PhoneCompare extends Component {
	constructor(props) {
		super(props);
		this.state = {
			items: [{}, {}, {}]
		}
	}

	componentDidMount() {

        var url = Global.getAPI(this.props.apiCallPath);
        fetch(url)
			.then(response => {
				if (response.status >= 400) {
					throw new Error("Error API: " + this.props.apiCallPath);
				}
				return response.json();
			})
			.then(data => {
				this.setState({
					items: data.items
				});
			})

	}


	render() {
		let apiState = this.props.apiCallPath;

		let bigBlock = <React.Fragment></React.Fragment>;

		if(apiState !== "smartphone-banners"){
			bigBlock = (
				<div className="col-md-12 col-sm-12 ad-3" >
					<div className="col-md-6 col-sm-6 texts">
						<h3>{this.state.items[2].headline}</h3>
						<div className="text">{this.state.items[2].text}</div>
						<div className="cutline"></div>
						<div className="priceAndBtnsWrap">
							<h5>{this.state.items[2].priceLabel}</h5>
							<div className="priceAndBtns">
								<div className="price"><span>$</span>{this.state.items[2].price}</div>
								{'\n'}
								<a href={this.state.items[2].ctaUrl} className="buy text-uppercase">{this.state.items[2].label}</a>
							</div>
						</div>
					</div>
					<div className="col-md-6  col-sm-6 image" style={{"backgroundImage":"url("+this.state.items[2].image+")"}}></div>
				</div>
			);
		}

		return <div className="scrolling-ad container clearfix">
			<div className=" hidden-xs">
				<div className="col-md-4 col-sm-4 ad-1" style={{"backgroundImage":"url("+this.state.items[0].image+")"}}>
					<h3>{this.state.items[0].headline}</h3>
					<div className="cutline"></div>
					<div className="text">{this.state.items[0].text}</div>
					<div className="btns">
						<a href={this.state.items[0].ctaUrl} className="buy text-uppercase">{this.state.items[0].label}</a>
					</div>
				</div>
				<div className="col-md-8 col-sm-8 ad-2" style={{"backgroundImage":"url("+this.state.items[1].image+")"}}>
					<h3>{this.state.items[1].headline1}<br/>{this.state.items[1].headline2}</h3>
					<div className="cutline"></div>
					<div className="text">{this.state.items[1].text}</div>
					<div className="btns">
						<a href={this.state.items[1].ctaUrl} className="buy text-uppercase">{this.state.items[1].label}</a>
					</div>
				</div>
				{bigBlock}
			</div>

			<div className="visible-xs-block mobileScrollingWrap">
				<Carousel items={this.state.items} apiCallPath={this.props.apiCallPath}/>
			</div>

		</div>
	}

}


export default PhoneCompare;